var exports = {
  "W2": "xe533113f--7c678e--scroll",
  "Sl": "xe533113f--7c678e--image",
  "xL": "xe533113f--7c678e--image-inner",
};

module.exports = exports;
